export default "__VITE_ASSET__f7b2c78a__"